/* eslint-disable */

export enum TimePeriodEnum {
    Days = "day",
    Months = "month",
    Years = "year",
}
